import type { StackProps } from './stack.types';

export const defaultStackProps: Required<StackProps> = {
	gap: 'spacing-4',
	align: 'stretch',
	justify: 'flex-start',
};
